class CommonVars
{
    static isLocalhost(url) 
    {
        return url.includes('localhost') || url.includes('127.0.0.1');
    }

    static API_URL = (CommonVars.isLocalhost(window.location.hostname) !== true ? 'https://retectionx.herokuapp.com' : 'http://localhost:3001');
}

export default CommonVars;